import { render, staticRenderFns } from "./ServiceAgentChangeModal.vue?vue&type=template&id=5def8070&scoped=true&"
import script from "./ServiceAgentChangeModal.vue?vue&type=script&lang=js&"
export * from "./ServiceAgentChangeModal.vue?vue&type=script&lang=js&"
import style0 from "./ServiceAgentChangeModal.vue?vue&type=style&index=0&id=5def8070&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5def8070",
  null
  
)

export default component.exports